import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "d-flex align-items-center mt-1" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", { selectedLanguage: _ctx.selectedLanguage }),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("b", { class: "me-1" }, "Translations:", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang, i) => {
        return (_openBlock(), _createElementBlock("button", {
          type: "button",
          class: _normalizeClass(["btn btn-small btn-link me-1", { active: _ctx.selectedLanguage == lang }]),
          key: i,
          onClick: ($event: any) => (_ctx.selectedLanguage = lang)
        }, _toDisplayString(lang), 11, _hoisted_3))
      }), 128))
    ])
  ]))
}